import { Row } from "react-styled-flexboxgrid";
import { HeroH2, HeroH3, HeroTitle } from "../../HeroSection";

const BannerText = (props) => {
  return (
    <>
      <Row>
        <HeroTitle>
          Promote your {props.businessType} directly to a community of locals
          and travellers.
        </HeroTitle>
      </Row>
      <Row>
        <HeroH2>
          Boost your direct bookings, expand your reach, and create a loyal
          customer base for years to come.
        </HeroH2>
      </Row>
      <Row>
        <HeroH3>
          Customers who share their personal recommendation of your business are
          priceless. Valmeego provides the easy means for any member to
          personally recommend your {props.businessType} to their family,
          friends and the wider Valmeego community.
        </HeroH3>
      </Row>
    </>
  );
};

export default BannerText;
